import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import AddBotanicalFamilyForm from "../../BotanicalFamily/AddBotanicalFamily/AddBotanicalFamilyForm";
import Loading from "../../Global/Loading";

const EditGrowthStage = () => {
  const { id } = useParams<any>();
  const { fetchData: editIncident, response: editResponse } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/growth_stages/${id}/edit/`,
    "PUT",
    false,
    "",
    true,
    true
  );

  const {
    response: getEditResponse,
    fetchData: getIncident,
    loading,
  } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/growth_stages/${id}/edit/`,
    "GET",
    false,
    "",
    true,
    true
  );

  const { t } = useTranslation();

  useEffect(() => {
    getIncident({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Growth stages.Edit growth stage")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Navbar.Settings"), url: "" },
          {
            name: t("Growth stages.Growth stages"),
            url: "/setting/growth-stages",
          },
          { name: t("Growth stages.Edit growth stage"), url: "" },
        ]}
      />
      {loading ? (
        <Loading loading={true} />
      ) : (
        <div className="flex flex-wrap justify-between mt-4">
          <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
            <AddBotanicalFamilyForm
              link="/setting/growth-stages"
              title={t("Growth stages.Growth stage")}
              send={editIncident}
              sendResponse={editResponse}
              getInfo={getEditResponse}
              textButton={t("Tree Species.Update")}
            />
          </div>
          <div className="w-full h-fit lg:w-[48%] sc:w-[559px] bg-white rounded-md p-8 mt-4 lg:mt-0">
            <img
              src="/img/Add growth stage.svg"
              alt="Edit growth stage"
              className="mt-4 ml-2 xl:ml-10"
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default EditGrowthStage;
